import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
// import { CourseService } from 'src/app/services/course.service';
// import { Store } from 'store';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { User, VisitedCourse } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
// import { User, VisitedCourse } from 'src/app/models/user.model';

declare var mixpanel;
@Component({
  selector: 'app-course-feedback-form',
  templateUrl: './course-feedback-form.component.html',
  styleUrls: ['./course-feedback-form.component.css']
})
export class CourseFeedbackFormComponent implements OnInit {


  @ViewChild('f') f: NgForm;
  @Input() courseTitle:string;
  @Input() courseTemplate:string;
  @Input() courseTrait:string;
  @Input() courseId:string;
  currentUserCourse:VisitedCourse
  @Output() isFormFilled: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  courseExperience:number;
  audioStoryFeedback:string;
  contentFeedback:string;
  exerciseFeedback:string;
  significantImprovement:string;
  isReferFriend:boolean;
  showFeedbackForm:boolean=false;
  isFormSubmitted:boolean=false;
  firstDivOut:boolean=false;
  user: User;
  exercisesHelped: string;
  testimonial:boolean=false;
  constructor(private courseService:CourseService,private store:Store,private activatedRoute:ActivatedRoute, private router: Router, ) { }

  ngOnInit() {
    setTimeout(()=>{
      this.firstDivOut = true;
    },2000);
    this.activatedRoute.params.subscribe(param=>{
      if(param){
        this.courseId = param['id'];
        if(this.courseId){
          this.store.select<User>('user').subscribe(user=>{
            if(user){
             let i =  user.visitedCourses.findIndex(vc=>vc.id===this.courseId);
             if(i>-1){
               this.currentUserCourse = user.visitedCourses[i];
               this.courseTemplate = this.currentUserCourse.templateName
               this.courseTrait = this.currentUserCourse.trait
               this.courseTitle = this.currentUserCourse.courseName
             }
            }
            this.user = user;
          })
        }
      }
    });
  }

  onSubmit(){
    let obj={templateName:this.courseTemplate,title:this.courseTitle,trait:this.courseTrait,...this.f.value}
    this.courseService.courseFeedbackForm(obj,this.courseId).subscribe(res=>{
      if(res.data){      
        this.isFormSubmitted = true;  
        mixpanel.track('Submit Feedback Form', { 
          'Course Name': this.currentUserCourse.courseName,
          'Course Template Name': this.currentUserCourse.templateName
        });
        setTimeout(()=>{
          this.onFormFilled();
        },3000);
      }
    })
  }

  markCourseAsCompleted(){
    this.courseService.markCourseCompleted(this.courseId).subscribe(res=>{
      if(res){
        this.router.navigate([`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`]);
        // window.open(`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`)
      }
    });
  }

  onFormFilled(){
    this.markCourseAsCompleted();
  }

  getFirstName() {
    return this.user.firstName.toUpperCase()
  }

}
